module.exports = __webpack_public_path__ + "img/DIU.a1c8768c.png";